function axis(nameOrOption) {
  const option = typeof nameOrOption === 'string' ? {name: nameOrOption} : nameOrOption

  return option
}

export default axis



// WEBPACK FOOTER //
// ./src/components/Chart/axies/axis.js